// src/types/seo/seoSite.ts
var PRODUCTION_HOST = "maatstays.com";
var CANONICAL_ORIGIN = `https://${PRODUCTION_HOST}`;
var SITE_NAME = "Maat Stays";
var DEFAULT_TITLE = "Vacation Rentals in Egypt | Chalets, Apartments & Villas \u2013 Maat Stays";
var DEFAULT_DESCRIPTION = "Book verified vacation rentals across Egypt \u2014 North Coast chalets, El Gouna villas, and Cairo furnished apartments. Flexible payments and installments. Book on Maat Stays.";
var SITE_ALTERNATE_NAMES = ["MAAT", "\u0645\u0627\u0639\u062A \u0633\u062A\u0627\u064A\u0632"];
var OG_LOCALE = "en_US";
var DEFAULT_SHARE_IMAGE = {
  url: `${CANONICAL_ORIGIN}/brand/maat-share-1200x630.png`,
  width: 1200,
  height: 630,
  alt: SITE_NAME
};
var SITE_LOGO_URL = `${CANONICAL_ORIGIN}/brand/maat-mark-1024.png`;
var isProductionHost = (hostname) => hostname.toLowerCase() === PRODUCTION_HOST;
var SEO_PATHS = {
  home: () => "/",
  listing: (id) => `/properties/listing/${encodeURIComponent(id)}`,
  property: (id) => `/stays/property/${encodeURIComponent(id)}`,
  experience: (id) => `/experiences/${encodeURIComponent(id)}`,
  service: (id) => `/services/${encodeURIComponent(id)}`,
  guide: (id) => `/guides/${encodeURIComponent(id)}`,
  guideDestination: (areaId) => `/guides/destinations/${encodeURIComponent(areaId)}`,
  host: (id) => `/hosts/${encodeURIComponent(id)}`,
  helpArticle: (slug) => `/help/articles/${encodeURIComponent(slug)}`,
  helpCategory: (slug) => `/help/categories/${encodeURIComponent(slug)}`
};

export {
  PRODUCTION_HOST,
  CANONICAL_ORIGIN,
  SITE_NAME,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
  SITE_ALTERNATE_NAMES,
  OG_LOCALE,
  DEFAULT_SHARE_IMAGE,
  SITE_LOGO_URL,
  isProductionHost,
  SEO_PATHS
};
